<template>
<div id="mainBlock">
    <!-- エラー確認ポップアップの表示 -->
    <Alert
        ref="Alert"
        :message="alertMessage"
        :subMessage="alertSubMessage"
        :errorFlag="errorFlag"
        @confirmFinished="confirmFinished"
    />
    <div id="blackPanel"></div>
    <!-- ユーザーの権限でadminページを開けないようにする -->
    <article v-if="!(!helpDisplay && this.pathCheck)">
        <div class="l-main helpPage">
            <div id="contentInner">
                <div class="helpPage">
                    <!-- ロールがmanagerかつ遷移したページで判断すること(GENERALUSERの場合は遷移させないこと) -->
                    <h1 v-if="helpDisplay && this.pathCheck">【端末管理者向け】LIVEアプリケーション ヘルプ</h1>
                    <h1 v-else>【データ閲覧者向け】 LIVEアプリケーション ヘルプ</h1>

                    <div class="article">
                        <p>
                            このサイトでは、LIVEの機能、使い方についての情報を掲載しています。<br>
                            ヘルプの記載内容で解決できない場合は、担当窓口までお問い合せください。
                        </p>
                    </div>

                    <h2>目次</h2>
                    <div class="article">
                        <ul>
                            <li><a href="#beginning">はじめに</a></li>
                            <li><a href="#notice">記載内容に関する注意事項</a></li>
                            <li><a href="#authtype">アカウントの権限について</a></li>
                            <li><a href="#display">画面の説明</a>
                                <ul>
                                    <li><a href="#disp_header">ヘッダー</a></li>
                                    <li><a href="#disp_sidebar">ナビゲーションバー</a></li>
                                    <li><a href="#disp_home">ホーム</a></li>
                                    <li><a href="#disp_live">ライブ</a></li>
                                    <li><a href="#disp_history">履歴</a></li>
                                    <!-- manager -->
                                    <li v-if="helpDisplay && this.pathCheck"><a href="#disp_setting">設定</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <a name="beginning"></a>
                    <h2>はじめに</h2>
                    <div class="article">
                        <p>
                            LIVEアプリケーションは、Webカメラで撮影したデータを閲覧できるWEBサービスです。<br>
                            リアルタイム再生や過去の撮影データの閲覧も可能です。<br>
                            <span v-if="this.pathCheck">
                                なお、本ヘルプは、LIVEアプリケーションの正常運用を目的として、
                                アプリケーションの状況を維持管理する端末管理者を対象として記述されています。
                            </span>
                        </p>
                    </div>

                    <a name="notice"></a>
                    <h2>記載内容に関する注意事項</h2>
                    <div class="article">
                        <p>
                            LIVEアプリケーションでは、PLATFORMにて設定されたユーザのロールによって、
                            利用可能な機能が変わります。<br>
                            <b>本ヘルプの記載内容と実際に利用可能な機能が異なっている場合がありますので、ご注意ください。</b>
                        </p>
                    </div>

                    <a name="authtype"></a>
                    <h2>アカウントの権限について</h2>
                    <div class="article">
                        <table>
                            <tbody>
                                <tr>
                                    <th><b>端末管理者</b></th>
                                    <td>自分の所属する企業かつ、自分の所属する端末グループに紐づく各種カメラの設定および撮影データの削除などが可能です。</td>
                                </tr>
                                <tr>
                                    <th><b>データ閲覧者</b></th>
                                    <td>自分の所属する企業かつ、自分の所属する端末グループに紐づく各種カメラの撮影データを閲覧することが可能です。</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>次節以降では、各設定メニューの詳細な操作方法について記述していきます。</p>
                    </div>

                    <a name="display"></a>
                    <h2>画面の説明</h2>
                    <div class="article">
                        <p>LIVE上の画面構成について説明します。</p>

                        <a name="disp_header"></a>
                        <h3>ヘッダー</h3>
                        <p>企業名の表示およびログアウトができます。</p>
                        <p v-if="width>=1024"><img src="../../assets/images/help/header.png"></p>
                        <p v-else><img src="../../assets/images/help/header_sp.png"></p>
                        <table>
                            <tbody>
                                <tr v-if="width>=1024">
                                    <th><b>[右側のアイコン]</b></th>
                                    <td>ヘルプおよびログアウトのメニューボタンを表示します。</td>
                                </tr>
                                <tr v-else>
                                    <th><b>[左側のアイコン]</b></th>
                                    <td>メニューを表示します。</td>
                                </tr>
                            </tbody>
                        </table>

                        <a name="disp_sidebar"></a>
                        <h3>ナビゲーションバー</h3>
                        <p>各画面への遷移ができます。</p>
                        <!-- manager -->
                        <div v-if="helpDisplay && this.pathCheck">
                            <p v-if="width>=1024"><img src="../../assets/images/help/sidebar1.png"></p>
                            <p v-else><img src="../../assets/images/help/sidebar_sp1.png"></p>
                        </div>
                        <!-- generaluser -->
                        <div v-else>
                            <p v-if="width>=1024"><img src="../../assets/images/help/sidebar2.png"></p>
                            <p v-else><img src="../../assets/images/help/sidebar_sp2.png"></p>
                        </div>
                        <table>
                            <tbody>
                                <tr>
                                    <th><b>ホーム</b></th>
                                    <td>ホーム画面へ遷移します。</td>
                                </tr>
                                <tr>
                                    <th><b>ライブ</b></th>
                                    <td>ライブ画面へ遷移します。</td>
                                </tr>
                                <tr>
                                    <th><b>履歴</b></th>
                                    <td>履歴画面へ遷移します。</td>
                                </tr>

                                <!-- manager -->
                                <tr v-if="helpDisplay && this.pathCheck">
                                    <th><b>設定</b></th>
                                    <td>設定画面へ遷移します。</td>
                                </tr>

                                <tr v-if="width<1024">
                                    <th><b>ヘルプ</b></th>
                                    <td>ヘルプ画面へ遷移します。</td>
                                </tr>
                                <tr v-if="width<1024">
                                    <th><b>ログアウト</b></th>
                                    <td>LIVEからログアウトします。</td>
                                </tr>
                            </tbody>
                        </table>

                        <a name="disp_home"></a>
                        <h3>ホーム</h3>
                        <p>端末グループに紐づいているカメラの当日分の撮影画像を閲覧できます。</p>
                        <p v-if="width>=1024"><img src="../../assets/images/help/home-header.png"></p>
                        <p v-else><img src="../../assets/images/help/home-header_sp.png"></p>
                        <table>
                            <tbody>
                                <tr>
                                    <th><b>カメラ名を入力</b></th>
                                    <td>該当する文字列のカメラを表示します。(部分入力可)</td>
                                </tr>
                                <tr>
                                    <th><b>カメラを選択</b></th>
                                    <td>閲覧するカメラ名を選択します。</td>
                                </tr>
                                <tr v-if="width>=1024">
                                    <th><b>表示サイズ</b></th>
                                    <td>画像の表示サイズを変更します。</td>
                                </tr>
                            </tbody>
                        </table>

                        <p v-if="width>=1024"><img src="../../assets/images/help/home.png"></p>
                        <p v-else><img src="../../assets/images/help/home_sp.png"></p>
                        <table>
                            <tbody>
                                <tr>
                                    <th><b>[カメラ電池アイコンを押下]</b></th>
                                    <td>電圧最終取得日時を表示します。</td>
                                </tr>
                                <tr>
                                    <th><b>[グラフアイコンを押下]</b></th>
                                    <td>電圧監視グラフ画面へ遷移します。</td>
                                </tr>
                                <tr>
                                    <th><b>[カメラ設定アイコンを押下]</b></th>
                                    <td>カメラ直接操作画面へ遷移します。</td>
                                </tr>
                                <tr v-if="width>=1024">
                                    <th><b>[画像右側の時間を押下]</b></th>
                                    <td>選択した時間に撮影した画像を表示します。</td>
                                </tr>
                                <tr v-else>
                                    <th><b>表示</b></th>
                                    <td>選択した時間に撮影した画像を表示します。</td>
                                </tr>
                            </tbody>
                        </table>

                        <a name="disp_live"></a>
                        <h3>ライブ</h3>
                        <p>端末グループに紐づいているカメラのリアルタイム映像を閲覧できます。</p>
                        <p v-if="width>=1024"><img src="../../assets/images/help/live.png"></p>
                        <p v-else><img src="../../assets/images/help/live_sp.png"></p>
                        <table>
                            <tbody>
                                <tr>
                                    <th><b>[画像を押下]</b></th>
                                    <td>選択したカメラのリアルタイム映像を再生します。</td>
                                </tr>
                            </tbody>
                        </table>

                        <a name="disp_history"></a>
                        <h3>履歴</h3>
                        <!-- manager -->
                        <p v-if="width>=1024 && helpDisplay && this.pathCheck">過去に撮影した動画の閲覧、ダウンロード、削除および静止画の閲覧ができます。</p>
                        <!-- generaluser -->
                        <p v-else>過去に撮影した動画の閲覧、ダウンロードおよび静止画の閲覧ができます。</p>
                        <p v-if="width>=1024"><img src="../../assets/images/help/history-header.png"></p>
                        <p v-else><img src="../../assets/images/help/history-header_sp.png"></p>
                        <table>
                            <tbody>
                                <tr>
                                    <th><b>カメラを選択</b></th>
                                    <td>閲覧するカメラ名を選択します。</td>
                                </tr>
                                <tr>
                                    <th><b>日付を選択</b></th>
                                    <td>閲覧する日付を選択します。「カメラを選択」でカメラ端末を選択後、押下できるようになります。</td>
                                </tr>
                                <tr>
                                    <th><b>種別を選択</b></th>
                                    <td>動画または静止画を選択します。</td>
                                </tr>
                                <tr>
                                    <th><b>適用</b></th>
                                    <td>選択対象の撮影データを取得します。</td>
                                </tr>
                            </tbody>
                        </table>

                        <p v-if="width>=1024"><img src="../../assets/images/help/history.png"></p>
                        <p v-else><img src="../../assets/images/help/history_sp.png"></p>
                        <table>
                            <tbody>
                                <tr v-if="width>=1024">
                                    <th><b>複数選択</b></th>
                                    <!-- manager -->
                                    <td v-if="helpDisplay && this.pathCheck">連続再生および削除する動画を選択します。</td>
                                    <!-- generaluser -->
                                    <td v-else>連続再生する動画を選択します。</td>
                                </tr>
                                <tr v-if="width>=1024">
                                    <th><b>一括ダウンロード</b></th>
                                    <td>1日分の動画をダウンロードします。</td>
                                </tr>
                                <tr>
                                    <th><b>[画像を押下]</b></th>
                                    <td>選択した動画を再生します。</td>
                                </tr>
                                <tr>
                                    <th><b>[画像右下のボタンを押下]</b></th>
                                    <td>選択した動画をダウンロードします。</td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- manager -->
                        <div v-if="helpDisplay && this.pathCheck">
                            <p v-if="width>=1024"><img src="../../assets/images/help/history-check-on1.png"></p>
                        </div>
                        <!-- generaluser -->
                        <div v-else>
                            <p v-if="width>=1024"><img src="../../assets/images/help/history-check-on2.png"></p>
                        </div>
                        <table v-if="width>=1024">
                            <tbody>
                                <tr>
                                    <th><b>キャンセル</b></th>
                                    <td>チェックボックスの表示状態を解除します。</td>
                                </tr>
                                <tr>
                                    <th><b>全選択</b></th>
                                    <td>全ての動画に対してチェックを有効にします。</td>
                                </tr>
                                <tr>
                                    <th><b>連続再生</b></th>
                                    <td>選択した動画を連続再生します。</td>
                                </tr>

                                <!-- manager -->
                                <tr v-if="helpDisplay && this.pathCheck">
                                    <th><b>削除</b></th>
                                    <td>選択した動画を削除します。</td>
                                </tr>

                            </tbody>
                        </table>

                        <p v-if="width>=1024"><img src="../../assets/images/help/history_image.png"></p>
                        <p v-else><img src="../../assets/images/help/history_image_sp.png"></p>
                        <table>
                            <tbody>
                                <tr>
                                    <th><b>[画像を押下]</b></th>
                                    <td>選択した画像を別タブで表示します。</td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- manager -->
                        <div v-if="helpDisplay && this.pathCheck">
                            <a name="disp_setting"></a>
                            <h3>設定</h3>
                            <p>各カメラの録画/停止、詳細設定および電圧監視設定が行えます。</p>
                            <p v-if="width>=1024"><img src="../../assets/images/help/setting-menu.png"></p>
                            <p v-else><img src="../../assets/images/help/setting-menu_sp.png"></p>
                            <table>
                                <tbody>
                                    <tr>
                                        <th><b>カメラ選択</b></th>
                                        <td>端末グループに紐づいているカメラの一覧を表示します。</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- manager -->
                        <div v-if="helpDisplay && this.pathCheck">
                            <p v-if="width>=1024"><img src="../../assets/images/help/setting-cam-list.png"></p>
                            <p v-else><img src="../../assets/images/help/setting-cam-list_sp.png"></p>
                            <table>
                                <tbody>
                                    <tr>
                                        <th><b>録画する</b></th>
                                        <td>対象のカメラの録画を開始します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>停止する</b></th>
                                        <td>対象のカメラの録画を停止します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>カメラ詳細設定</b></th>
                                        <td>カメラ詳細設定画面へ遷移します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>電圧監視設定</b></th>
                                        <td>電圧監視設定画面へ遷移します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>カメラ直接操作</b></th>
                                        <td>カメラ直接操作画面へ遷移します。</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- manager -->
                        <div v-if="helpDisplay && this.pathCheck">
                            <p v-if="width>=1024"><img src="../../assets/images/help/setting-cam-detail.png"></p>
                            <p v-else><img src="../../assets/images/help/setting-cam-detail_sp.png"></p>
                            <table>
                                <tbody>
                                    <tr v-if="width>=1024">
                                        <th><b>クリア</b></th>
                                        <td>入力内容を削除します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>変更を保存</b></th>
                                        <td>各項目の入力内容を登録します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>カメラ名</b></th>
                                        <td>カメラ名を入力します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>カメラURL</b></th>
                                        <td>カメラURLを入力します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>RTSPポート番号</b></th>
                                        <td>RTSPポート番号を入力します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>表示順</b></th>
                                        <td>カメラ一覧画面に表示される順番を入力します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>機種名</b></th>
                                        <td>カメラの機種名を選択します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>認証</b></th>
                                        <td>カメラの認証情報を入力します。</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- manager -->
                        <div v-if="helpDisplay && this.pathCheck">
                            <p v-if="width>=1024"><img src="../../assets/images/help/setting-widget.png"></p>
                            <p v-else><img src="../../assets/images/help/setting-widget_sp.png"></p>
                            <table>
                                <tbody>
                                    <tr v-if="width>=1024">
                                        <th><b>クリア</b></th>
                                        <td>入力内容を削除します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>変更を保存</b></th>
                                        <td>各項目の入力内容を登録します。</td>
                                    </tr>
                                    <tr>
                                        <th><b>シリアル番号</b></th>
                                        <td>電圧監視設定用のシリアル番号を入力します。</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</div>
</template>

<script>
const logoutUrl = process.env.VUE_APP_HADER_ICON_URL;
import Alert from '../modal/Alert'
export default {
    name: 'HelpDetailsComponent',
    data: function(){
        return {
            // ウィンドウのサイズを保持するために使用
            width: window.innerWidth,
            // 「端末管理者」から遷移しているか判定をする
            pathCheck: this.$route.params.id == 'details_livepro_admin' ? true : false,
            // アラートモーダル用のパーツ
            alertMessage: '',
            alertSubMessage: '',
            errorFlag: false,
        }
    },
    props:{
        siteInfo:{
            type: Array
        },
        cameraInfo:{
            type: Array
        }
    },
    methods: {
        handleResize: function() {
            this.width = window.innerWidth;
        },
        //**********************************************************/
        // 確認モーダル用のデータの受け渡し
        /**********************************************************/
        showResultMessage(result) {
            this.$refs.Alert.showConfirm();
            this.alertMessage = result.message;
            this.alertSubMessage = result.sub_message;
            this.conrfirmResult = result
            this.errorFlag = result.errorFlag;
        },
        //**********************************************************/
        // 確認モーダル処理
        /**********************************************************/
        confirmFinished() {
            if (this.conrfirmResult.transitionLogoutPageFlg) {
                sessionStorage.clear();
                window.location.href = logoutUrl;
            }
            if (this.conrfirmResult.transitionTopPageFlg) {
                window.location.href = '/home?site_no=' + this.$store.getters['auth/getSiteNo'];
            }
            if (this.conrfirmResult.execFlg) {
                this.getThumnailImageInfo();
            }
        },
    },
    computed: {
        /**********************************************************/
        // 権限による「端末管理者」用ヘルプの表示非表示
        /**********************************************************/
        helpDisplay() {
            return this.$userRoleAuthorization('help', 'helpDisplay');
        },
    },
    mounted: function() {
        //**********************************************************/
        // 権限がない場合にログアウト画面にリダイレクトする処理
        // userの権限でadminのページを見に来た時にはじく
        /**********************************************************/
        if(!this.$userRoleAuthorization('help', 'helpDisplay') && this.pathCheck){
            this.showResultMessage({
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: true,
                execFlg: false,
                message:"権限エラー",
                sub_message:"アクセス権がありません。",
                errorFlag: true
            });
        }
        //*********************************************************/
        // 画面描写後にローディングをはずす
        /**********************************************************/
        this.$emit('loadFinish');

        // 画面リサイズ時に横幅を計算する
        window.addEventListener('resize', this.handleResize)
    },
    components: {
        Alert,
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/help/HelpDetailsComponent.css";
</style>